/* Ratings & reviews — the behaviour behind the section's two buttons.

   The reviews themselves are rendered server-side from Judge.me's metafield,
   so nothing here draws anything. "Write Review" opens Judge.me's own form by
   clicking the button inside the app block this section keeps off-screen. */
(function () {
  'use strict';

  /* Judge.me has two widgets in circulation — the revamped one (`jm-*`) and
     the older one (`jdgm-*`) — and serves either while it dual-publishes. */
  function writeLink(root) {
    return root.querySelector(
      '.jmrv__app .jm-action-buttons__button,' +
        '.jmrv__app .jm-review-widget-minimal-header__button-and-filters .jm-button,' +
        '.jmrv__app .jm-button--primary,' +
        '.jmrv__app .jdgm-write-rev-link,' +
        '.jmrv__app .jdgm-widget-actions-wrapper a'
    );
  }

  function setup(root) {
    var moreBtn = root.querySelector('[data-jmrv-more]');
    var writeBtn = root.querySelector('[data-jmrv-write]');

    if (writeBtn && !writeBtn.dataset.ljBound) {
      writeBtn.dataset.ljBound = '1';
      writeBtn.addEventListener('click', function () {
        var link = writeLink(root);
        if (link) link.click();
      });
    }

    if (moreBtn && !moreBtn.dataset.ljBound && moreBtn.tagName !== 'A') {
      moreBtn.dataset.ljBound = '1';
      moreBtn.addEventListener('click', function () {
        root.classList.add('jmrv--expanded');
        if (root.querySelectorAll('.jmrv__review').length > Number(root.dataset.visible || 3)) {
          moreBtn.hidden = true;
        }
      });
    }

    /* A button with no form behind it is worse than no button. The app block
       renders server-side, so this resolves on the first pass without a
       flash — it only hides if the block was removed from the section. */
    if (writeBtn) writeBtn.hidden = !writeLink(root);

    /* The reference shows both buttons as a pair whatever the review count, so
       this one is not hidden when there is nothing left to reveal — it is only
       hidden after a click has expanded the list. */
  }

  function init() {
    document.querySelectorAll('[data-jmrv]').forEach(function (root) {
      setup(root);

      /* Judge.me mounts its widget asynchronously, so the write-review target
         can appear after this first pass. */
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          setup(root);
        });
      }).observe(root, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
